import { render, staticRenderFns } from "./ProfileLangSelect.vue?vue&type=template&id=0f0a50cd&scoped=true&"
import script from "./ProfileLangSelect.vue?vue&type=script&lang=js&"
export * from "./ProfileLangSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProfileLangSelect.vue?vue&type=style&index=0&id=0f0a50cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0a50cd",
  null
  
)

export default component.exports